import OrderResolvedScreen from './OrderResolvedScreen.component';

export default OrderResolvedScreen;
